import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BusResultsContainer } from './bus-results.container';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';
import { filtersRoute } from '@flight-results/flight-results-routing.constants';
import { FlightsFiltersContainer } from '@shared/filters/components/flights-filters/flights-filters.container';
import {
  BusResultsMobileItineraryRouteDetailComponent
// eslint-disable-next-line max-len
} from '@shared/bus-itinerary/components/bus-results-mobile-itinerary-route-detail/bus-results-mobile-itinerary-route-detail.component';
import { busResultsBaseRoute } from './constanst/bus-routes.constants';

export const busResultsRootRoute = busResultsBaseRoute;
export const routeDetail = 'route-detail';
export const calendarRoute = 'calendar';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: BusResultsContainer
      },
      {
        path: ':bus_type/:departure/:arrival/:departure_date/:arrival_date/:adults/:company',
        component: BusResultsContainer,
        children: [
          {
            path: calendarRoute,
            outlet: 'detail',
            component: SearchBarMobileCalendarContainer,
          },
          {
            path: routeDetail,
            outlet: 'detail',
            component: BusResultsMobileItineraryRouteDetailComponent
          },
          {
            path: filtersRoute,
            outlet: 'detail',
            component: FlightsFiltersContainer
          },
        ]
      },
      {
        path: ':bus_type/:departure/:arrival/:departure_date/:adults/:company',
        component: BusResultsContainer,
        children: [
          {
            path: calendarRoute,
            outlet: 'detail',
            component: SearchBarMobileCalendarContainer,
          },
          {
            path: routeDetail,
            outlet: 'detail',
            component: BusResultsMobileItineraryRouteDetailComponent
          },
          {
            path: filtersRoute,
            outlet: 'detail',
            component: FlightsFiltersContainer
          },
        ]
      },
    ])
  ],
  exports: [RouterModule]
})
export class BusResultsRoutingModule { }
